export default __webpack_public_path__ + "static/media/Q2-4.518ba22a.png";